import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class GastroOrdersService extends RestfulService<Models.GastroOrder> {

  constructor(public restService: RestService) {
    super(Models.GastroOrder);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('gastro-orders');
  }
}
